import { CmsVendor } from "@modules/graphql/types"
import { FormattedMessage } from "@modules/locales"
import { cmsIntegration as cmsIntegrationText } from "@modules/locales/default.js"
import { Link } from "gatsby-interface"
import {
  cmsVendorFormattedName,
  getCmsVendorIntegrationDocLink,
  getGatsbyProvisionReadmeLink,
} from "../utils/cmsInformations"

const GatsbyProvisionLearnMoreMessage = ({
  cmsVendor,
}: {
  cmsVendor: Extract<CmsVendor, CmsVendor.Contentful | CmsVendor.Sanity>
}) => {
  return (
    <FormattedMessage<"cmsVendor", "a1" | "a2" | "code">
      message={cmsIntegrationText.messages.deployNowGatsbyProvisionLearnMore}
      values={{
        cmsVendor: cmsVendorFormattedName[cmsVendor],
      }}
      tags={{
        a1: function(content) {
          const gatsbyProvisionPackageReadmeLink = getGatsbyProvisionReadmeLink(
            cmsVendor
          )
          return (
            <Link href={gatsbyProvisionPackageReadmeLink} target="_blank">
              {content}
            </Link>
          )
        },
        a2: function(content) {
          const cmsVendorIntegrationDocLink = getCmsVendorIntegrationDocLink(
            cmsVendor
          )
          return (
            <Link href={cmsVendorIntegrationDocLink} target="_blank">
              {content}
            </Link>
          )
        },
        code: function(content) {
          return <code>{content}</code>
        },
      }}
    />
  )
}

export default GatsbyProvisionLearnMoreMessage
